import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { Product, Variant } from 'shared/types/product';
import { LineItem } from 'shared/types/wishlist/LineItem';
import { useFormat } from 'helpers/hooks/useFormat';
import { useAccount, useCart } from 'frontastic';
import Link from '../../atoms/link';
import CustomfitOptions from '../product/product-details/components/customfit-options';
import { discardRepeatedValues } from '../product/product-details/helpers/discardRepeatedValues';
import WishlistButton from '../wishlist/components/wishlist-button';
import Prices from '../product/product-tile/prices';
import CustomfitVariant from '../product/product-details/components/customfit-variant';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';
import { promotionCategory } from '../product/product-details/types';
import { SmartLink } from 'components/commercetools-ui/atoms/smart-link';

export interface Props {
  product: Product;
  iscategoryUpdated?: any;
}

const ProductTile: React.FC<Props> = ({ product, iscategoryUpdated }) => {
  const router = useRouter();
  const [customFitPrice, setCustomFitPrice] = useState<number | null>(
    product?.customFitDetails?.CF_Price?.GBP as number,
  );

  const localeSelection = getCurrencyCookie('locale_selection');
  const currency: string | null = localeSelection?.currency || null;

  useEffect(() => {
    if (currency === 'EUR') {
      setCustomFitPrice(product?.customFitDetails?.CF_Price?.EUR || null);
    } else if (currency === 'GBP') {
      setCustomFitPrice(product?.customFitDetails?.CF_Price?.GBP || null);
    }
  }, [currency, product]);
  const promotionCategory = product?.categories as promotionCategory[] | undefined;

  const newArrivals = promotionCategory?.find((i: promotionCategory) => i?.name === 'New Arrivals');
  const convertProductNameToUrl = (input: string | undefined) => {
    const urlformat = `${input?.toLowerCase().replace(/\s+/g, '-')}`;
    const url = urlformat?.endsWith('-') ? urlformat : `${urlformat}-`;
    return url?.replace(/,/g, '');
  };

  return (
    <>
      <div className="mx-2 flex min-h-[700] w-[100%] flex-col items-start justify-center px-3">
        <div className="grow">
          <SmartLink
            href={`${product?.categories?.[0]?._name}/${
              convertProductNameToUrl(product?.name) + product?.slug + '.html'
            }`}
            className="block shrink-0 grow basis-0"
          >
            <div className="p-3">
              <div className="relative mb-4 flex w-full items-center justify-center">
                <img src={product?.variants?.[0]?.images?.[0]} width={240} alt={product?.name} height={240} />
                {newArrivals && (
                  <button className="absolute right-10 top-8 h-[72px] w-[72px] rounded-full bg-[#127E57] p-5 font-body text-[22px] font-extrabold leading-4 text-white">
                    {'New'}
                  </button>
                )}
              </div>
              <div className="w-[240px] text-start">
                <p className="font-body text-16 font-semibold leading-[19.2px] ">{product?.name}</p>
              </div>
            </div>
          </SmartLink>
        </div>
        <div className="mb-10  mt-4 text-start">
          <Prices price={product?.variants?.[0]?.price} discountedPrice={product?.variants?.[0]?.discountedPrice} />
        </div>

        <div className="w-full">
          <SmartLink href={`/${product?._url}`}>
            <button
              className="h-[48px] w-full rounded-md bg-[#43d6a2] p-4 font-body text-16
              font-bold uppercase leading-[19.2px] text-black"
            >
              VIEW PRODUCT
            </button>
          </SmartLink>
        </div>
      </div>
    </>
  );
};

export default ProductTile;
